import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { Observable, timer } from 'rxjs';
import { GenericHealthService } from '@lsq-frontend/angular-shared/features/generic-get-services';
import { forLifeOf, LifecycleAware } from '../../../utilities/rxjs.helpers';

@LifecycleAware()
@Component({
    selector: 'lsq-unavailable',
    template: `
        <div class="container-fluid page-container page">
            <div class="error-page-container">
                <div class="error-page-copy">
                    <h1>Service Unavailable</h1>
                    <p>
                        We are actively working to restore service.
                    </p>
                    <p class="text-gray-600" [style.margin-top]="'1rem'">
                        Checking again in {{ secondsToNextPoll }}
                        {{ secondsToNextPoll | i18nPlural: { '=1': 'second', other: 'seconds' } }}.
                        You will be automatically redirected to Dashboard when service is restored.
                    </p>
                </div>

                <div class="error-page-image-container"></div>
            </div>
        </div>
    `
})
export class LsqUnavailableComponent implements OnInit, OnDestroy {
    private _pollPeriod = 15 * 1000;
    private _clockInterval: Observable<number>;
    public secondsToNextPoll = this._pollPeriod / 1000;

    constructor(@Inject(GenericHealthService) private _healthService: GenericHealthService) {}

    public ngOnInit(): void {
        this._clockInterval = timer(0, 1000);
        this._clockInterval.pipe(forLifeOf(this)).subscribe((secondsElapsed) => {
            this.secondsToNextPoll = this._pollPeriod / 1000 - (secondsElapsed % 15);
            if (this.secondsToNextPoll === 1) {
                this._healthService.execute();
            }
        });

        this._healthService.dataStream.pipe(forLifeOf(this)).subscribe(() => {
            window.location.reload();
        });
    }

    public ngOnDestroy(): void {}
}
